import { createPortal } from "react-dom";

/* ------------------------------------------------------------------
   AddMoreButton
------------------------------------------------------------------- */
export default function AddMoreButton({ label, onClick }) {  
  const fab = (
    <button
      className="btn-rcv-x-fab"
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <span aria-hidden="true">+</span>
    </button>
  );

  return (
    <>
      <button className="btn-rcv-x-add" type="button" onClick={onClick}>
        <span className="btn-rcv-x-add-icon" aria-hidden="true">+</span>
        {label}
      </button>

      {typeof document !== "undefined"
        ? createPortal(fab, document.body)
        : null}
    </>
  );
}

